import { createRouter, createWebHashHistory } from 'vue-router';

import { featureFlagGuard } from './guards/featureFlags';
import { entitlementGuard } from './guards/entitlementGuard';
import routes from './routes';
import { installRouterChunkLoadRecovery } from '@/utils/chunkLoadRecovery';

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Docs own scrolling, including anchors rendered after dataset metadata loads.
    if (['api-docs', 'api-docs-auth'].includes(to.name) && to.hash) return false;
    return savedPosition || { top: 0 };
  },
});

router.beforeEach(featureFlagGuard);
router.beforeEach(entitlementGuard);
installRouterChunkLoadRecovery(router);

export default router;
